import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../../../actions";
import strings from "../../../helpers/Localization";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import dayjs from "dayjs";
import dayjsPluginUTC from "dayjs/plugin/utc";
dayjs.extend(dayjsPluginUTC);

import QRCode from "react-qr-code";

import { toast } from "react-toastify";

//CUSTOM COMPONENT
import PaginationList from "../../../aGlobalDesign/Pagination/PaginationList";
import ButtonSkaRound from "../../../aGlobalDesign/Buttons/ButtonSkaRound";
import Inputs from "../../../aGlobalDesign/Inputs/Inputs";
import Modal from "../../../aGlobalDesign/Modal/Modal";
import IconComponent from "../../../aGlobalDesign/Icons/IconComponent";

class URLRecallClients extends React.Component {

    constructor() {
        super();
        this.state = {
            searchField: "",
            openModal: 0,
            selectedCallLink: null,
            temporaryElement: null,
            forcePaginationUpdate: 0,
            isModalCallTransfersOpen: false,
            openCalendarDatesDialog: "",
            openDialogDateSelector: false,
            zoneList: null,
            callCentersList: null,
            callCentersListFiltered: null,
            userAgentsList: null,
            target: strings.CallCenter,
            timeValidity: [
                { id: 1, hours: 1, name: 1 + " " + strings.time },
                { id: 2, hours: 2, name: 2 + " " + strings.times },
                { id: 4, hours: 4, name: 4 + " " + strings.times },
                { id: 24, hours: 24, name: 24 + " " + strings.times },
                { id: 168, hours: 168, name: 7 + " " + strings.days },
                { id: 720, hours: 720, name: 30 + " " + strings.days }
            ],
            openSendLinkModal: false,
            sendCallLink: {
                name: null,
                callURL: null,
                typeContact: strings.TextMessage,
                contact: null
            }
        };
    }

    componentDidMount() {
        this.props.changeAppBarTitle(strings.ClientsRecall);
        this.props.ChangeCurrentMenuName("ClientsRecall");

        const accessRight = 20;
        this.props.GetRestrictedZones((data) => {
            if (accessRight < 20 || !data.results || data.results.length <= 0) {
                this.setState({ zoneList: [] });
            }
            else {
                this.setState({
                    zoneList: data
                });
            }
        }, accessRight
        );

    }
    forcePaginationUpdate() {
        const temp = this.state.forcePaginationUpdate + 1;
        this.setState({
            selectedCallLink: null,
            openModal: 0,
            forcePaginationUpdate: temp
        });
    }
    componentDidUpdate(prevProps, prevState) {
        const reload = this.props.reload;
        if (reload && this.props.reload !== prevProps.reload) {
            this.forcePaginationUpdate();
        }

        if (prevState.callCentersList !== this.state.callCentersList) {
            this.getCallCenterAndAgentFiltered();
        }

        if (this.props.createNew !== prevProps.createNew) {
            this.OnLoad(null);
        }
    }

    getCallCenterAndAgentFiltered(element) {
        const typeCallLink = "instant";
        const autoAddOwnCallCenter = true;
        this.props.CallCentersForCallLink((data, typeCallLink ) => {
            let listCallCenters;
            if (element) {
                listCallCenters = this.state.zoneList.results.find(zz => zz.id === element.zoneId).secondaryList;
            }
            else {
                listCallCenters = this.state.zoneList.results[0].secondaryList;
            }

            const callCenters = data;
            const agents = [];
            const callCentersFiltered = [];

            const currentorganizationId = this.props.currentuser.currentorganization.id;
            const currentOrganization = this.props.currentuser.user.organizationUsers.find(orga => orga.organizationId === currentorganizationId);
            const userCallCenter = currentOrganization.callCenterId;

            listCallCenters.forEach((ccList) => {
                callCenters.forEach((cc) => {
                    if (cc.id === ccList.id) {
                        const callCenterAlreadyExists = callCentersFiltered.some(c => c.id === cc.id);
                        if (!callCenterAlreadyExists) {
                            callCentersFiltered.push(cc);
                        }
                        if (cc.portalAgents.length > 0) {
                            cc.portalAgents.forEach((agent) => {
                                agent.users.forEach((user) => {
                                    const alreadyExists = agents.some(u => u.id === user.id);
                                    if (!alreadyExists) {
                                        agents.push({
                                            ...user,
                                            portalLinked: {
                                                id: agent.id,
                                                name: agent.name,
                                                isAvailable: agent.isAvailable,
                                                uniqueIdentifier: agent.uniqueIdentifier,
                                                callCenterId: cc.id
                                            }
                                        });
                                    }
                                });
                            });
                        }
                    }
                });
            });

            this.setState({
                callCentersListFiltered: callCentersFiltered,
                userAgentsList: agents
            });
        },
        typeCallLink, autoAddOwnCallCenter
        );
    }

    getFormattedUTC(date) {
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, "0");
        const day = String(date.getUTCDate()).padStart(2, "0");
        const hours = String(date.getUTCHours()).padStart(2, "0");
        const minutes = String(date.getUTCMinutes()).padStart(2, "0");

        return `${year}-${month}-${day} ${hours}:${minutes}`;
    }



    //#region functions
    OnDelete(id, onSuccess) {
        this.props.OpenDialog({
            title: strings.deleteConfirm,
            description: strings.textDeleteURLCall,
            secondaryLabel: strings.cancel,
            primaryLabel: strings.confirmDelete,
            onPrimaryAction: () => {
                this.props.DeleteFreeCallLink(id, () => {
                    this.forcePaginationUpdate();
                });
            }
        });
    }
    OnLoad(callLink) {
        const now = new Date();
        const addHour = new Date(now.getTime()); // default if validityPeriod is 1 hour, add 1 hour from now
        addHour.setHours(addHour.getHours() + 1);

        let d = callLink;
        if (d === null) {
            d = {
                id: 0,
                permanent: false,
                name: "",
                validityPeriod: 1, // default selected 1 hour
                organizationId: this.props.currentuser.currentorganization.id,
                dateStartString: this.getFormattedUTC(now),
                dateEndString: this.getFormattedUTC(addHour),
                zoneId: null,
                callCenterId: null, // There is a callCenterId if cible is callCenter and also if cible is agent
                idUser: null, // If cible is agent only
                disabled: false,
                categoryId: null,
                callURL: null,
                data: null
            };
        }
        else {
            const start = new Date(d.dateStartString.replace(" ", "T") + ":00Z");
            const end = new Date(d.dateEndString.replace(" ", "T") + ":00Z");

            const diffMs = end - start;
            const diffHours = diffMs / (1000 * 60 * 60);

            d.validityPeriod = diffHours;
        }
        const temp = this.CreateTemp(d);

        this.getCallCenterAndAgentFiltered(callLink);



        this.setState({
            callCentersList: callLink === null ? null : this.state.zoneList.results.find(zz => zz.id === d.zoneId).secondaryList,
            selectedCallLink: d,
            openModal: 1,
            temporaryElement: temp
        });
    }
    CreateTemp(element) {
        const temp = {
            id: element.id,
            permanent: element.permanent,
            organizationId: element.organizationId,
            name: element.name,
            validityPeriod: element.validityPeriod,
            dateStartString: element.dateStartString,
            dateEndString: element.dateEndString,
            zoneId: element.zoneId,
            callCenterId: element.callCenterId,
            idUser: element.idUser,
            disabled: element.disabled,
            categoryId: element.categoryId,
            callURL: element.callURL,
            data: element.data
        };
        return temp;
    }
    SaveTemp(temp, element) {
        element.name = temp.name;
        element.permanent = temp.permanent;
        element.validityPeriod = temp.validityPeriod;
        element.dateStartString = temp.dateStartString;
        element.organizationId = temp.organizationId;
        element.dateEndString = temp.dateEndString;
        element.zoneId = temp.zoneId;
        element.callCenterId = temp.callCenterId;
        element.idUser = temp.idUser;
        element.disabled = temp.disabled;
        element.categoryId = temp.categoryId;
        element.callURL = temp.callURL;
        element.data = temp.data;
        return element;
    }
    saveSelectedCallLink() {
        const callLink = this.state.selectedCallLink;
        this.SaveTemp(this.state.temporaryElement, callLink);
        if ( callLink.name === "") {
            this.props.OpenDialog({
                description: strings.mustHaveCallLinkName,
                primaryLabel: "OK",
                clickOutsideToClose: true
            });
            return;
        }

        const d = {
            id: callLink.id,
            permanent: callLink.permanent,
            organizationId: callLink.organizationId,
            name: callLink.name,
            validityPeriod: callLink.validityPeriod,
            dateStartString: callLink.dateStartString,
            dateEndString: callLink.dateEndString,
            zoneId: callLink.zoneId,
            callCenterId: callLink.callCenterId,
            idUser: callLink.idUser,
            disabled: callLink.disabled,
            categoryId: callLink.categoryId,
            callURL: callLink.callURL,
            data: callLink.data
        };

        if (callLink.id === 0) {
            this.props.CreateFreeCallLink(d,
                (id) => {
                    toast.success(strings.CallLinkCreated);
                    this.forcePaginationUpdate();
                    this.props.GetSecondaryFreeCallLinkList((data) => {});
                });
        }
        else {
            this.props.EditFreeCallLink(
                d,
                (updatedcallLinkTimestamp) => {
                    toast.success(strings.CallLinkSaved);
                    this.forcePaginationUpdate();
                    this.props.GetSecondaryFreeCallLinkList((data) => {});
                }
            );
        }

        this.setState({ target: strings.CallCenter });
    }

    getDayName(daynum) {
        const locale = "fr-FR";
        const baseDate = new Date(Date.UTC(2017, 0, daynum));
        const dayName = baseDate.toLocaleDateString(locale, { weekday: "long" });
        return dayName.charAt(0).toUpperCase() + dayName.slice(1);
    }
    getHourInput(value, period, onChange) {
        return (
            <input className="TextField-small-filled" type="time"
                style={{ flexGrow: "1", flexShrink: "0", fontSize: "14px", backgroundColor: "var(--input-background)" }}
                placeholder={"hh:mn"}
                disabled={this.state.preview}
                min={period && period === "am" ? "00:01" : period && period === "pm" ? "10:00" : null }
                max={period && period === "am" ? "17:00" : period && period === "pm" ? "23:59" : null }
                value={value}
                onChange={onChange}
            />
        );
    }
    ConvertDateForExceptions(range) {
        // Replace space with "T" for to be have a compatibled date with ISO
        const dateStr = range.replace(" ", "T");

        const date = new Date(dateStr);

        if (isNaN(date)) {
            console.error("Invalid date:", dateStr);
            return "";
        }

        const dayOfWeek = date.toLocaleDateString("fr-FR", { weekday: "long" });
        const capitalizedDayOfWeek = dayOfWeek.charAt(0).toUpperCase() + dayOfWeek.slice(1);

        const dateFormatted = date.toLocaleDateString("fr-FR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
        }).replace(/\//g, ".");

        return `${capitalizedDayOfWeek} ${dateFormatted}`;
    }
    getStatus(el) {
        const datestart = el.dateStartString ? dayjs.utc(el.dateStartString).local() : null;
        const dateend = el.dateEndString ? dayjs.utc(el.dateEndString).local() : null;
        const now = dayjs().local();

        if (datestart && datestart > now) {return strings.Programmed;}
        else if (dateend && dateend < now) {return strings.Expired;}
        else {return "Actif";}
    }

    isValidContact() {
        // For phone number
        if (this.state.sendCallLink.typeContact === strings.TextMessage) {
            const parsedNumber = parsePhoneNumberFromString(this.state.sendCallLink.contact);
            return parsedNumber && parsedNumber.isValid() || false;
        }
        // For email
        else {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.state.sendCallLink.contact);
        }
    }




    //#endregion

    render() {
        const accessrights = this.props.currentuser && this.props.currentuser.accessrights ? this.props.currentuser.accessrights : null;
        return <>
            <PaginationList
                forcePaginationUpdate={this.state.forcePaginationUpdate}

                onGetElements={this.props.GetReCallLinksList}
                onSavePagination={this.props.SaveReCallLinksPagination}
                myElements={this.props.monitoring.recalllinks }

                sortOptions={[
                    { sortName: "name", sortData: "null" },
                    { sortName: "status", sortData: "null" },
                    { sortName: "zone", sortData: "null" },
                    { sortName: "callcenter", sortData: "null" },
                    { sortName: "agent", sortData: "null" }
                ]}

                tableElement={(element, onReloadList) => {
                    return [
                        {
                            colTitle: strings.SortURL,
                            fixedWidth: "300px",
                            cellRenderer: ({ tableManager, stringvalue, field, data, column, colIndex, rowIndex }) => {
                                const value = data[column.field];
                                if (value && value.callURL) {
                                    return <div style={{ display: "flex", flexDirection: "row", gap: "0px", alignItems: "center", justifyItems: "center" }}>
                                        <span style={{ overflow: "hidden", flexGrow: 1, width: "250px", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                            {value.callURL.replace("https://", "").replace(".azurewebsites.net", "")}
                                        </span>
                                        <button type='button' className="button-round-secondary-icon-without-text" style={{ border: "transparent" }}
                                            onClick={() => {
                                                navigator.clipboard.writeText(value.callURL);
                                                toast.success(strings.CopiedToClipboard);
                                            }}>
                                            <IconComponent nameIcon="clipboardcopy" color="carbone" dimensions="24"/>
                                        </button>
                                    </div>;
                                }
                                else {return "";}
                            },
                            colContent: element ? {
                                callURL: element.callURL
                            } : null
                        },
                        {
                            colTitle: strings.SortStatus,
                            sortIndex: 1,
                            fixedWidth: "90px",
                            lockWidth: true,
                            colContent: element ? this.getStatus(element) : null
                        },
                        {
                            colTitle: strings.SortDescriptive,
                            sortIndex: 0,
                            fixedWidth: "160px",
                            colContent: element ? element.name : null
                        },
                        {
                            colTitle: strings.SortZone,
                            sortIndex: 2,
                            fixedWidth: "160px",
                            colContent: element && element.zone ? element.zone.name : null
                        },
                        {
                            colTitle: strings.SortCallCenter,
                            sortIndex: 3,
                            fixedWidth: "160px",
                            colContent: element && element.callCenter ? element.callCenter.name : null
                        },
                        {
                            colTitle: strings.SortAgent,
                            sortIndex: 4,
                            fixedWidth: "160px",
                            colContent: element && element.user?.displayName ? element.user.displayName : null
                        },
                        {
                            colTitle: strings.LinkValidity,
                            fixedWidth: "320px",
                            colContent: !element || !(element.dateStartString || element.dateEndString) ? null :
                                (element.dateStartString ? dayjs.utc(element.dateStartString).local().format("DD-MM-YYYY HH:mm") : "") + " ‣ " + (element.dateEndString ? dayjs.utc(element.dateEndString).local().format("DD-MM-YYYY HH:mm") : "")

                        },
                        {
                            colTitle: strings.SortActions,
                            colType: "actions",
                            // TO DO => Edit with 5 actions when add send button below
                            // actions: [1, 2, 3, 4, 5],
                            actions: [1, 2, 3, 4],
                            colContent: [
                                <ButtonSkaRound
                                    key={"view"}
                                    type="primary"
                                    isDisabled={!accessrights || accessrights.hasPermission(430, "consult") <= 10}
                                    onClick={() => {
                                        this.setState({ preview: true });
                                        this.OnLoad(element);
                                    }}
                                    nameIcon="eye"
                                />,
                                <ButtonSkaRound
                                    key={"edit"}
                                    type="primary"
                                    isDisabled={!accessrights || accessrights.hasPermission(430, "modify") <= 10}
                                    onClick={() => this.OnLoad(element)}
                                    nameIcon="edit"
                                />,
                                // TO DO => Add button send call link by mail or phone
                                // <ButtonSkaRound
                                //     key={"send"}
                                //     type="primary"
                                //     isDisabled={!accessrights || accessrights.hasPermission(430, "modify") <= 10}
                                //     onClick={() => {
                                //         const dp = this.state.sendCallLink;
                                //         dp.name = element.name;
                                //         dp.callURL = element.callURL;
                                //         this.setState({
                                //             openSendLinkModal: true,
                                //             sendCallLink: dp
                                //         });
                                //     }}
                                //     nameIcon="send"
                                // />,
                                <ButtonSkaRound
                                    key={"qrcode"}
                                    type="primary"
                                    isDisabled={!accessrights || accessrights.hasPermission(430, "consult") <= 10}
                                    onClick={() => {
                                        this.setState({ openQRCodeModal: element.callURL });
                                    }}
                                    nameIcon="qrcode"
                                />,
                                <ButtonSkaRound
                                    key={"trash"}
                                    type="primary"
                                    isDisabled={!accessrights || accessrights.hasPermission(430, "delete") <= 10}
                                    onClick={() => this.OnDelete(element.id)}
                                    nameIcon="trash"
                                />
                            ]
                        }
                    ];
                }}
            />
            <Modal open={this.state.openModal === 1}
                icon={this.state.preview ? "infoCircle" : this.state.selectedCallLink && this.state.selectedCallLink.id !== 0 ? "edit" : "add"}
                onClose={() => {
                    if (!this.state.preview) {
                        this.forcePaginationUpdate();
                        this.setState({ target: strings.CallCenter });
                    }
                    else {
                        this.setState({
                            selectedCallLink: null,
                            openModal: 0,
                            temporaryElement: null,
                            preview: false
                        });
                    }
                }}
                title={this.state.preview ? strings.detailsLink : this.state.selectedCallLink && this.state.selectedCallLink.id !== 0 ? strings.ModifyLink : strings.CreateLink}
                validationIcon={this.state.selectedCallLink && this.state.selectedCallLink.id !== 0 ? "save" : "check"}
                validationTitle={this.state.selectedCallLink && this.state.selectedCallLink.id !== 0 ? strings.register : strings.Validate}
                disableValidate={this.state.temporaryElement && (!this.state.temporaryElement.zoneId || !this.state.temporaryElement.callCenterId || !this.state.temporaryElement.dateStartString || !this.state.temporaryElement.dateEndString)}
                onValidate={ !this.state.preview ? () => this.saveSelectedCallLink() : null }
            >
                {
                    this.state.temporaryElement ?
                        <>
                            { this.state.temporaryElement.callURL && this.state.temporaryElement.callURL !== "" ?
                                <Inputs field={{
                                    type: "textfield",
                                    allowCopy: true,
                                    title: strings.feedUrl,
                                    disabled: true,
                                    value: this.state.temporaryElement.callURL,
                                    onChange: (e) => { }
                                }}/> : null
                            }
                            <Inputs field={{
                                type: "textfield",
                                title: strings.descriptif,
                                disabled: this.state.preview,
                                placeholder: strings.name,
                                error: this.state.temporaryElement.name === "",
                                value: this.state.temporaryElement.name,
                                onChange: (e) => {
                                    const dp = this.state.temporaryElement;
                                    dp.name = e.target.value;
                                    this.setState({ temporaryElement: dp });
                                }
                            }}/>
                            <Inputs field={{
                                type: "selectElement",
                                title: strings.Type,
                                disabled: true,
                                adjustHeight: true,
                                preventEmpty: true,
                                elementsList: { results: [
                                    { id: 1, name: strings.Permanent },
                                    { id: 2, name: strings.ClientsRecall }
                                ] },
                                selectedElementId: this.state.temporaryElement.permanent ? 1 : 2,
                                onSelectElement: (element) => {
                                    const dp = this.state.temporaryElement;
                                    dp.permanent = element.id;
                                    this.setState({
                                        temporaryElement: dp
                                    });
                                } }}
                            />
                            <Inputs field={{
                                type: "selectElement",
                                title: strings.validity,
                                disabled: this.state.preview,
                                adjustHeight: true,
                                preventEmpty: true,
                                elementsList: { results: this.state.timeValidity },
                                selectedElementId: this.state.temporaryElement.validityPeriod,
                                onSelectElement: (element) => {
                                    const dp = { ...this.state.temporaryElement };
                                    dp.validityPeriod = element.hours;

                                    const date = new Date(dp.dateStartString.replace(" ", "T") + ":00Z");
                                    date.setHours(date.getHours() + element.hours);


                                    dp.dateEndString = this.getFormattedUTC(date);

                                    this.setState({
                                        temporaryElement: dp
                                    });
                                } }}
                            />
                            {
                                this.state.zoneList && this.state.zoneList.results ?
                                    <Inputs field={{
                                        type: "selectElement",
                                        title: strings.Zone,
                                        disabled: this.state.preview,
                                        adjustHeight: true,
                                        preventEmpty: true,
                                        elementsList: this.state.zoneList,
                                        selectedElementId: this.state.temporaryElement.zoneId,
                                        onSelectElement: (element) => {
                                            const dp = this.state.temporaryElement;
                                            dp.zoneId = element.id;
                                            dp.callCenterId = element.secondaryList[0].id;
                                            this.setState({
                                                callCentersList: element.secondaryList,
                                                temporaryElement: dp
                                            });
                                        } }}
                                    />
                                    :
                                    <p style={{ marginLeft: "110px", fontWeight: 600 }}>{strings.NoCallCenterWithThisUser}</p>
                            }
                            {
                                this.state.temporaryElement.zoneId ?
                                    <Inputs field={{
                                        type: "circlesquareradiobuttons",
                                        title: strings.Target,
                                        elements: [
                                            {
                                                name: strings.CallCenter,
                                                disabled: this.state.preview,
                                                checked: !this.state.temporaryElement.idUser && this.state.target === strings.CallCenter,
                                                onClick: () => {
                                                    const dp = this.state.temporaryElement;
                                                    dp.idUser = null;
                                                    this.setState({
                                                        target: strings.CallCenter,
                                                        temporaryElement: dp
                                                    });
                                                }
                                            },
                                            {
                                                name: strings.agent,
                                                disabled: this.state.preview,
                                                checked: this.state.target === strings.agent || this.state.temporaryElement.idUser !== null,
                                                onClick: () => {
                                                    const dp = this.state.temporaryElement;
                                                    dp.idUser = this.state.temporaryElement.idUser ?
                                                        this.state.temporaryElement.idUser
                                                        : this.state.userAgentsList && this.state.userAgentsList[0]
                                                            ? this.state.userAgentsList[0].id
                                                            : null;

                                                    const agentUser = this.state.userAgentsList.find(agent => agent.id === dp.idUser );
                                                    dp.callCenterId = agentUser.portalLinked.callCenterId;
                                                    this.setState({
                                                        target: strings.agent,
                                                        temporaryElement: dp
                                                    });
                                                }
                                            }
                                        ]
                                    }}/>
                                    :
                                    null
                            }

                            {
                                this.state.temporaryElement.zoneId && !this.state.temporaryElement.idUser && this.state.target === strings.CallCenter ?
                                // --- Target CallCenter ---
                                    (() => {
                                        const callCenters = this.state.callCentersListFiltered || [];
                                        const selectedCCId = callCenters.some(c => c.id === this.state.temporaryElement.callCenterId)
                                            ? this.state.temporaryElement.callCenterId
                                            : undefined;

                                        return (
                                            <Inputs field={{
                                                type: "selectElement",
                                                openTop: true,
                                                title: strings.CallCenter,
                                                disabled: this.state.preview || callCenters.length === 0,
                                                preventEmpty: callCenters.length > 0,
                                                adjustHeight: true,
                                                elementsList: { results: callCenters },
                                                selectedElementId: selectedCCId,
                                                onSelectElement: (element) => {
                                                    const dp = { ...this.state.temporaryElement };
                                                    dp.callCenterId = element.id;
                                                    dp.idUser = null;
                                                    this.setState({ temporaryElement: dp });
                                                }
                                            }}/>
                                        );
                                    })()
                                    :
                                    this.state.temporaryElement.zoneId ?
                                    // --- Target Agent ---
                                        (() => {
                                            const agents = this.state.userAgentsList || [];
                                            const selectedUserId = agents.some(u => u.id === this.state.temporaryElement.idUser)
                                                ? this.state.temporaryElement.idUser
                                                : undefined;

                                            return (
                                                <Inputs field={{
                                                    type: "selectElement",
                                                    openTop: true,
                                                    title: strings.agent,
                                                    disabled: this.state.preview || agents.length === 0,
                                                    preventEmpty: agents.length > 0,
                                                    adjustHeight: true,
                                                    elementsList: { results: agents },
                                                    selectedElementId: selectedUserId,
                                                    onSelectElement: (element) => {
                                                        const dp = { ...this.state.temporaryElement };
                                                        dp.idUser = element.id;
                                                        const agentUser = this.state.userAgentsList.find(agent => agent.id === dp.idUser );
                                                        dp.callCenterId = agentUser.portalLinked.callCenterId;

                                                        this.setState({ temporaryElement: dp });
                                                    }
                                                }}/>
                                            );
                                        })()
                                        :
                                        null

                            }


                            <Inputs field={{
                                type: "dateTimeSelector",
                                title: strings.ValidFrom,
                                modalTitle: strings.StartValidationDate,
                                disabled: true,
                                value: this.state.temporaryElement.dateStartString ? dayjs.utc(this.state.temporaryElement.dateStartString).local().format("YYYY-MM-DD HH:mm") : null,
                                onChange: (dateoutput) => {
                                    const endate = this.state.temporaryElement.dateEndString ? dayjs.utc(this.state.temporaryElement.dateEndString).local() : null;
                                    if (this.state.preview) {return;}
                                    const dp = this.state.temporaryElement;
                                    if (!endate || endate >= dayjs(dateoutput)) {
                                        dp.dateStartString = dayjs(dateoutput).utc().format("YYYY-MM-DD HH:mm");
                                    }
                                    else {
                                        dp.dateStartString = dp.dateEndString;
                                        dp.dateEndString = dayjs(dateoutput).utc().format("YYYY-MM-DD HH:mm");
                                    }
                                    this.setState({ temporaryElement: dp });
                                }
                            }}
                            />
                            <Inputs field={{
                                type: "dateTimeSelector",
                                title: strings.At,
                                modalTitle: strings.EndValidationDate,
                                disabled: true,
                                value: this.state.temporaryElement.dateEndString ? dayjs.utc(this.state.temporaryElement.dateEndString).local().format("YYYY-MM-DD HH:mm") : null,
                                onChange: (dateoutput) => {
                                    const startdate = this.state.temporaryElement.dateStartString ? dayjs.utc(this.state.temporaryElement.dateStartString).local() : null;
                                    if (this.state.preview) {return;}
                                    const dp = this.state.temporaryElement;
                                    if (!startdate || startdate <= dayjs(dateoutput)) {
                                        dp.dateEndString = dayjs(dateoutput).utc().format("YYYY-MM-DD HH:mm");
                                    }
                                    else {
                                        dp.dateEndString = dp.dateStartString;
                                        dp.dateStartString = dayjs(dateoutput).utc().format("YYYY-MM-DD HH:mm");
                                    }
                                    this.setState({ temporaryElement: dp });
                                }
                            }}
                            />
                        </> : null
                }
            </Modal>
            <Modal open={this.state.openSendLinkModal}
                icon="send"
                onClose={() => {
                    this.setState({
                        openSendLinkModal: false,
                        sendCallLink: {
                            name: null,
                            callURL: null,
                            typeContact: strings.TextMessage,
                            contact: null
                        }
                    });
                }}
                title={strings.SendCallLink}
                validationIcon={"check"}
                validationTitle={strings.Validate}
                disableValidate={!this.state.sendCallLink.contact || !this.isValidContact()}
                onValidate={() => {
                    this.setState({
                        openSendLinkModal: false
                    });
                    // TO DO send link
                    console.log("Object of call link sended", this.state.sendCallLink);

                    // Clean sendCallLink object when link is sended
                    setTimeout(() => {
                        this.setState({
                            sendCallLink: {
                                name: null,
                                callURL: null,
                                typeContact: strings.TextMessage,
                                contact: null
                            }
                        });
                    }, 3000);
                }}
            >
                {
                    <>
                        <Inputs field={{
                            type: "textfield",
                            title: strings.descriptif,
                            placeholder: strings.name,
                            value: this.state.sendCallLink && this.state.sendCallLink.name,
                            onChange: (e) => {
                                const dp = this.state.sendCallLink;
                                dp.name = e.target.value;
                                this.setState({
                                    sendCallLink: dp
                                });
                            }
                        }}/>
                        <Inputs field={{
                            type: "circlesquareradiobuttons",
                            title: strings.Target,
                            elements: [
                                {
                                    name: strings.TextMessage,
                                    checked: this.state.sendCallLink.typeContact === strings.TextMessage,
                                    disabled: this.state.preview,
                                    onClick: () => {
                                        const dp = this.state.sendCallLink;
                                        dp.typeContact = strings.TextMessage;
                                        this.setState({
                                            sendCallLink: dp
                                        });
                                    }
                                },
                                {
                                    name: strings.email,
                                    checked: this.state.sendCallLink.typeContact === strings.email,
                                    disabled: this.state.preview,
                                    onClick: () => {
                                        const dp = this.state.sendCallLink;
                                        dp.typeContact = strings.email;
                                        this.setState({
                                            sendCallLink: dp
                                        });
                                    }
                                }
                            ]
                        }}/>
                        {
                            this.state.sendCallLink.typeContact === strings.TextMessage ?
                                <Inputs field={{
                                    title: strings.MobileNumber,
                                    type: "phone",
                                    // openTop: true,
                                    value: this.state.sendCallLink.contact,
                                    onChange: (val) => {
                                        const dp = this.state.sendCallLink;
                                        dp.contact = val;
                                        this.setState({ sendCallLink: dp });
                                    }
                                }}/>
                                :
                                <Inputs field={{
                                    type: "textfield",
                                    title: strings.email,
                                    placeholder: strings.email,
                                    value: this.state.sendCallLink.contact,
                                    onChange: (e) => {
                                        const dp = this.state.sendCallLink;
                                        dp.contact = e.target.value;
                                        this.setState({ sendCallLink: dp });
                                    }
                                }}/>
                        }
                    </>

                }
            </Modal>
            <Modal open={this.state.openQRCodeModal}
                icon="qrcode"
                onClose={() => {
                    this.setState({
                        openQRCodeModal: null
                    });
                }}
                title={strings.QRCode}
                validationIcon={"export"}
                validationTitle={strings.Download}
                onValidate={() => {
                    const svgContainer = document.querySelector("#QRCodeContainer");
                    if (svgContainer) {
                        const svgElement = svgContainer.innerHTML;
                        const blob = new Blob([svgElement], { type: "text/plain" });
                        const url = URL.createObjectURL(blob);
                        const link = document.createElement("a");
                        link.download = "qrCode.svg";
                        link.href = url;
                        link.click();
                    }
                }}
            >
                {
                    <div style={{ width: "100%", alignItems: "center", display: "flex", flexDirection: "column" }}>
                        <div style={{ width: "256px", padding: "20px" }} id="QRCodeContainer">
                            {
                                this.state.openQRCodeModal ?
                                    <QRCode
                                        size={256}
                                        style={{ height: "auto", width: "auto" }}
                                        value={this.state.openQRCodeModal}
                                        viewBox={"0 0 256 256"}
                                    />
                                    :
                                    null
                            }

                        </div>
                    </div>
                }
            </Modal>
        </>;
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActionsCreators, dispatch);
};

export default connect(
    (state) => state,
    mapDispatchToProps
)(URLRecallClients);
